import { telegramSupport, whatsappSupport, lineSupport } from "./constants";
import { getSupportLink } from "./utils";

/**
 * Resolves the support channel for the current user.
 *
 * Priority: user's preferred notification channel, then community fallback
 * (tw → LINE, my → WhatsApp, else Telegram). Inside the mobile app the
 * contactMethod is "app" (the in-app Sotravel Team chat) but supportLink is
 * still the resolved external link — pre-OTA app builds only handle
 * navigateToSupportChat messages that carry a url, and they open it
 * externally (newer builds ignore the url and open the Team chat).
 *
 * @returns {{ supportLink: string, contactMethod: "app"|"telegram"|"whatsapp"|"line" }}
 */
export const resolveSupportContact = (user, community) => {
  let supportLink;
  let contactMethod;

  if (user?.preferred_notification_channel === "whatsapp") {
    supportLink = whatsappSupport;
    contactMethod = "whatsapp";
  } else if (user?.preferred_notification_channel === "line") {
    supportLink = lineSupport;
    contactMethod = "line";
  } else if (user?.preferred_notification_channel === "telegram") {
    supportLink = telegramSupport;
    contactMethod = "telegram";
  } else if (community === "tw") {
    supportLink = lineSupport;
    contactMethod = "line";
  } else if (community === "my") {
    supportLink = whatsappSupport;
    contactMethod = "whatsapp";
  } else {
    supportLink = getSupportLink(community);
    contactMethod = "telegram";
  }

  if (window.isInApp) {
    contactMethod = "app";
  }

  return { supportLink, contactMethod };
};

/**
 * Opens the resolved support channel: the in-app Sotravel Team chat when
 * running inside the mobile app, otherwise the external link in a new tab.
 */
export const openSupportChannel = (supportLink) => {
  if (window.isInApp && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: "navigateToSupportChat",
        url: supportLink,
      })
    );
    return;
  }

  if (supportLink) {
    window.open(supportLink, "_blank", "noreferrer noopener");
  }
};
